module.exports = __webpack_public_path__ + "static/media/logo-white.ec8fbdd3.jpg";